export default __webpack_public_path__ + "static/media/river_bg_old.571c8810.jpg";